import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useForm } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import * as yup from 'yup';
import { FormAutocomplete } from '../../common/form';
import { RootState } from '../../store';
import { connectPricelistCustomers, hideConnectPricelistDialog } from './redux/pricelistSlices';

const mapStateToProps = (state: RootState) => ({
    pricelists: state.pricelist.pricelists,
    customers: state.customers.customers
});

type OwnProps = {
    customerId: number | undefined;
    pricelistId: number | undefined;
};

type PricelistConnectionForm = {
    customerId: number;
    pricelistId: number;
};
type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ConnectPricelistDialog = ({ customerId, pricelistId, pricelists, customers }: Props) => {
    const schema: yup.SchemaOf<PricelistConnectionForm> = yup.object().shape({
        customerId: yup.number().required().label('Customer'),
        pricelistId: yup.number().required().label('Pricelist')
    });

    const dispatch = useDispatch();
    const { handleSubmit, control } = useForm<PricelistConnectionForm>({
        resolver: yupResolver(schema),
        defaultValues: { pricelistId, customerId }
    });

    const handleClose = () => {
        dispatch(hideConnectPricelistDialog());
    };

    const connectPricelistCustomer = (request: PricelistConnectionForm) => {
        dispatch(connectPricelistCustomers.request({ ...request }));
    };

    return (
        <Dialog open={true}>
            <DialogTitle>Connect pricelist to customer</DialogTitle>
            <DialogContent>
                <FormAutocomplete
                    sx={{ margin: 1 }}
                    control={control}
                    name="pricelistId"
                    label="Pricelist"
                    options={Object.values(pricelists).map(p => p.pricelistId)}
                    getOptionLabel={p => pricelists[p]?.name}
                    disabled={!!pricelistId}
                />
                <FormAutocomplete
                    sx={{ margin: 1 }}
                    label="Customer"
                    control={control}
                    name="customerId"
                    options={Object.values(customers).map(p => p.customerId)}
                    getOptionLabel={p => customers[p]?.name}
                    disabled={!!customerId}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button color="primary" type="submit" onClick={handleSubmit(connectPricelistCustomer)}>
                    Connect
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default connect(mapStateToProps)(ConnectPricelistDialog);
